import "./LegalRequirements.module.css";
import Header from "@/reusable_sections/Header";
import Regulationshero from "./sections/Regulationshero";
import Regulations from "./sections/Regulations";
import Compliance from "./sections/Compliance";
import Regulation from "./sections/Regulation";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function LegalRequirementsPage() {
  return <div>
      <Header />
      <Regulationshero />
      <Regulations />
      <Compliance />
      <Regulation />
      <Contact />
      <Footer />
    </div>;
}